import { Link } from 'react-router-dom'

export default () => (
  <div className="container text-center pt-5">
    <Link to="/" className="fa fa-compass fa-5x" />
  </div>
);
